package nl.volleyplanner.web.textconverters

import nl.volleyplanner.api.entities.PublicPerson
import nl.volleyplanner.api.planner.ConstraintScoreImpact
import nl.volleyplanner.api.planner.PlannerTaskAssignmentConstraint
import nl.volleyplanner.api.planner.Task
import nl.volleyplanner.api.types.BigNumber
import nl.volleyplanner.sportconfig.NevoboTeamName
import nl.volleyplanner.web.base.text.shortDisplayLabel

object TaskLabelConverter {
    fun taskNameReadable(task: Task) : String {
        return when(task.name) {
            "ScoreKeeper" -> "Teller"
            "Referee" -> "Scheidsrechter"
            else -> task.name
        }
    }

    fun assigneeNameUIString(task: Task?) : String {
        val person = task?.assignee?.personAssignee
        if (person == null) return "-"
        val team = person.groups?.get("Team")?.map { NevoboTeamName.parse(it.name) }
            // Youth should always first be in their own category
            ?.minWith(compareBy<NevoboTeamName> {it.ageGroup}.thenByDescending { it.teamNumber })

        val displayName = "${person.name} ${team?.shortDisplayLabel() ?: "VL"}".trim()

        // TODO: Handle this exception case in an elegant way. Likely need custom assignment types here
        return if (task.assignee.isParent == true) {
            "$displayName (Ouder/Verzorger)"
        } else {
            displayName
        }
    }

    fun toHumanReadable(constraintLabel: PlannerTaskAssignmentConstraint): String {
        return when (constraintLabel) {
            PlannerTaskAssignmentConstraint.IsUnavailable -> "Niet beschikbaar voor taak"
            PlannerTaskAssignmentConstraint.HasNoMatch -> "Heeft geen wedstrijd"
            PlannerTaskAssignmentConstraint.HasNoMatchPerson -> "Totaal taken zonder wedstrijd"
            PlannerTaskAssignmentConstraint.EvenlySpreadOverPersons -> "Verdeling taken"
            PlannerTaskAssignmentConstraint.MatchProportionalTaskLoad -> "Verdeling taken"
            PlannerTaskAssignmentConstraint.PrioritizeByFairness -> "Fijnafstemming verdeling"
            PlannerTaskAssignmentConstraint.DeprioritizeRefereeAsScoreKeeper -> "Scheidsrechter als teller"
            PlannerTaskAssignmentConstraint.EvenlySpreadOverTeamsPerDay -> "Verdeling mensen uit team"
            PlannerTaskAssignmentConstraint.PrioritizeRefereeGroup -> "Niet-preferente scheidsrechter"
            PlannerTaskAssignmentConstraint.MinimizePersonTotalWaitingTime -> "Wachttijd alle taken"
            PlannerTaskAssignmentConstraint.MinimizeWaitingTime -> "Wachttijd voor taak"
            PlannerTaskAssignmentConstraint.NotPreferredForThisTask -> "Niet in primaire groep"
            PlannerTaskAssignmentConstraint.TryAssignTeamOnSameDay -> "Verdeling team"
            PlannerTaskAssignmentConstraint.AssignTeamMembersAtSameTime -> "Team op dezelfde tijd"
            PlannerTaskAssignmentConstraint.VolunteerExemption -> "Vrijwilligersvrijstelling"
            else -> constraintLabel.name
        }
    }
}

fun ConstraintScoreImpact.toUIString() : String {
    val constraintNameLabel = TaskLabelConverter.toHumanReadable(constraint.constraintName)
    val scoreToDisplay = when {
        impact.softScore != BigNumber.ZERO -> impact.softScore
        impact.mediumScore != BigNumber.ZERO -> impact.mediumScore
        impact.hardScore != BigNumber.ZERO -> impact.hardScore
        else -> BigNumber.ZERO
    }
    return if (humanReadableImpact != null) {
        // TODO: human readable constraint name
        "${constraintNameLabel} (${scoreToDisplay}: ${humanReadableImpact})"
    } else {
        "${constraintNameLabel} (${scoreToDisplay})"
    }
}